module.exports = __webpack_public_path__ + "static/media/search.cdc2e283.svg";